import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { CardIconTitleDescription } from '@rappider/rappider-components';
import { Action, ActionBehavior } from '@rappider/rappider-components/utils';
import { AiAbstractChatComponent } from '../ai-abstract-chat/ai-abstract-chat.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rappider-ai-entity-visualization',
  standalone: true,
  imports: [
    CommonModule,
    AiAbstractChatComponent
  ],
  templateUrl: './ai-entity-visualization.component.html',
  styleUrls: ['./ai-entity-visualization.component.scss']
})
export class AiEntityVisualizationComponent implements OnInit, OnDestroy {

  selectedProjectModelId?: string;
  private subscriptions: Subscription[] = [];

  actionCardItems?: CardIconTitleDescription[] = [
    {
      id: 'sample-action-card-id',
      title: 'Sample Action Card',
      key: 'sample-action-card',
      iconName: 'fa fa-solid fa-calendar-check',
      description: 'Sample action card description',
    }
  ];

  actionButtons?: Action[] = [
    {
      id: 'sample-action-id',
      text: 'Sample Action Button',
      icon: { name: 'fa fa-solid fa-calendar-check' },
      redirectUrl: '/some-path',
      tooltipText: 'Sample Action Button Tooltip',
      behavior: ActionBehavior.Emit
    }
  ];

  constructor(private route: ActivatedRoute) {
    // Constructor intentionally left empty
  }

  ngOnInit(): void {
    this.subscriptions = [
      this.subscribeToRouteParameters()
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  /**
   * Subscribe to route parameter changes
   * @returns Subscription for route parameters
   */
  subscribeToRouteParameters(): Subscription {
    return this.route.paramMap.subscribe((params: ParamMap) => {
      const routeProjectModelId = params.get('projectModelId') ?? undefined;
      if (routeProjectModelId && routeProjectModelId !== this.selectedProjectModelId) {
        this.selectedProjectModelId = routeProjectModelId;
      }
    });
  }
}
